"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityRequest = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var service_1 = require("../../../library/base/service");
var inviteActivity_1 = require("../../model/inviteActivity");
var ActivityRequest = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ActivityRequest, _super);
    function ActivityRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '查询活动信息';
        _this.code = '300414';
        _this.desc = '查询活动信息';
        _this.requestParams = new inviteActivity_1.ActivityInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ActivityRequest;
}(service_1.BaseService));
exports.ActivityRequest = ActivityRequest;
//# sourceMappingURL=activityRequest.js.map